export default __webpack_public_path__ + "f10c8b462e89a98a712c7021dc2bd2ea.ttf";